// extracted by mini-css-extract-plugin
module.exports = {"logo":"LogoText_logo__17QUa"};